
import { Suspense, lazy } from "react";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/components/theme/ThemeProvider";
import { AccessCodeProvider } from "@/contexts/AccessCodeContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import LandingPage from "./pages/LandingPage";
import Index from "./pages/Index";
import Contact from "./pages/Contact";
import About from "./pages/About";

const queryClient = new QueryClient();

// Lazy load pages
const ServicesPage = lazy(() => import("./pages/ServicesPage"));
const PricingPage = lazy(() => import("./pages/Pricing"));
const SocialMedia = lazy(() => import("./pages/SocialMedia"));
const FixMySite = lazy(() => import("./pages/FixMySite"));

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AccessCodeProvider>
          <TooltipProvider>
            <Toaster />
            <BrowserRouter>
              <div className="flex flex-col min-h-screen bg-white text-black">
                <Header />
                <main className="flex-1 pt-16">
                  <Suspense fallback={<div>Loading...</div>}>
                    <Routes>
                      <Route path="/" element={<LandingPage />} />
                      <Route path="/project-form" element={<Index />} />
                      <Route path="/services" element={<ServicesPage />} />
                      <Route path="/tools" element={<ServicesPage />} />
                      <Route path="/pricing" element={<PricingPage />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/social-media" element={<SocialMedia />} />
                      <Route path="/fix-my-site" element={<FixMySite />} />
                      
                      {/* New service routes - all redirect to a coming soon page for now */}
                      <Route path="/instagram-feed" element={<ServicesPage />} />
                      <Route path="/popup-forms" element={<ServicesPage />} />
                      <Route path="/google-business" element={<ServicesPage />} />
                      <Route path="/mobile-check" element={<ServicesPage />} />
                      <Route path="/link-in-bio" element={<ServicesPage />} />
                      <Route path="/tracking-pixels" element={<ServicesPage />} />
                      <Route path="/speed-optimizer" element={<ServicesPage />} />
                      <Route path="/website-copy" element={<ServicesPage />} />
                      <Route path="/social-proof" element={<ServicesPage />} />
                    </Routes>
                  </Suspense>
                </main>
                <Footer />
              </div>
            </BrowserRouter>
          </TooltipProvider>
        </AccessCodeProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
